// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components----main-module---main---3yBrp","carouselFlex":"src-components----main-module---carouselFlex---3PZKc","text":"src-components----main-module---text---39W0z","textScaleY":"src-components----main-module---textScaleY---18p0I","name":"src-components----main-module---name---1-5eY","spec":"src-components----main-module---spec---2nD2y","sub":"src-components----main-module---sub---2F9Qd","contact":"src-components----main-module---contact---3bL4s","flex":"src-components----main-module---flex---kJqtY","carouselImg":"src-components----main-module---carouselImg---D9QoJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/main.module.css
// module id = 172
// module chunks = 35783957827783